import { Component, OnInit } from '@angular/core';
import { EnglishTranslation, MalayTranslation } from '../app.constants';

@Component({
  selector: 'app-make-appointment-thank-you',
  templateUrl: './make-appointment-thank-you.component.html',
  styleUrls: ['./make-appointment-thank-you.component.scss']
})
export class MakeAppointmentThankYouComponent implements OnInit {
  textContent: any;
  productDescription : string;

  constructor() { }

  ngOnInit() {
    this.productDescription = JSON.parse(localStorage.URLParam).ProductDescription;
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.AppointmentScreen : MalayTranslation.AppointmentScreen;
  }

}
